import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	width: 100%;
`;

export const Row = styled.button<{ $selected?: boolean }>`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 6px 8px;
	border: none;
	border-radius: 4px;
	background-color: ${({ theme, $selected }) => ($selected ? theme.blue[300] : 'transparent')};
	transition: background-color 0.15s ease;
	text-align: left;
	font: inherit;
	width: 100%;
	position: relative;

	&:hover {
		background-color: ${({ theme, $selected }) =>
			$selected ? theme.blue[300] : theme.gray[100]};
	}
`;

export const Tooltip = styled.div`
	position: absolute;
	bottom: 100%;
	left: 50%;
	transform: translateX(-50%) translateY(-4px);
	background-color: ${({ theme }) => theme.gray[900]};
	color: ${({ theme }) => theme.gray[0]};
	padding: 6px 10px;
	border-radius: 6px;
	font-size: 12px;
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
		'Courier New', monospace;
	white-space: nowrap;
	pointer-events: none;
	opacity: 0;
	transition: opacity 0.2s ease;
	z-index: 10;

	${Row}:hover & {
		opacity: 1;
	}

	&::after {
		content: '';
		position: absolute;
		top: 100%;
		left: 50%;
		transform: translateX(-50%);
		border: 6px solid transparent;
		border-top-color: ${({ theme }) => theme.gray[900]};
	}
`;

export const Name = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[900]};
	width: 140px;
	flex-shrink: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const BarTrack = styled.div`
	flex: 1;
	max-width: 300px;
	height: 12px;
	display: flex;
	align-items: center;
`;

export const Bar = styled.div<{ $fraction: number }>`
	width: ${({ $fraction }) => Math.max($fraction * 100, 1)}%;
	height: 100%;
	background-color: ${({ theme }) => theme.blue[500]};
	border-radius: 2px;
	min-width: ${({ $fraction }) => ($fraction === 0 ? '2px' : '4px')};
	transition: width 0.2s ease;
`;

export const Value = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[700]};
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
		'Courier New', monospace;
	width: 60px;
	text-align: right;
	flex-shrink: 0;
`;
